<section 
  class="register-user__movility-field"
  [formGroup]="form()"
>
  <mat-form-field 
    class="register-user__form-field" 
    appearance="outline"
    subscriptSizing="dynamic"
  >
    <mat-label
      class="ci-paragraph-p2-regular"
    >
      @if (cityLocation()) {
        ¿{{ 'Cómo llegas' | translate }}
        <span> a {{ cityLocation() | translate }}?</span>
      } @else {
        ¿{{ 'Cómo llegas' | translate }}?
      }
    </mat-label>
    <mat-select
      [formControlName]="formControlName()"
      (selectionChange)="handleMovilityTypeChange($event)"
    >
      @for (movilityType of movilityTypes; track movilityType.value) {
        <mat-option 
          [value]="movilityType.value"
        >
          {{ movilityType.name | translate }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</section>